import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ChatCircleDots, SignOut, House, Gear } from "@phosphor-icons/react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const handleLogout = async () => {
    await logout();
    nav("/");
  };

  const isActive = (p) => loc.pathname === p || loc.pathname.startsWith(p + "/");

  return (
    <nav className="border-b-2 border-[#121212] bg-[#FDFBF7] sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2" data-testid="nav-logo">
          <div className="w-9 h-9 bg-[#A7E4C0] border-2 border-[#121212] rounded-lg flex items-center justify-center">
            <ChatCircleDots size={20} weight="bold" />
          </div>
          <div className="font-display font-black text-xl tracking-tight">Layanan lainnya RS Mulya</div>
        </Link>
        {user ? (
          <div className="flex items-center gap-2">
            <Link to="/dashboard" className={`nb-btn ${isActive("/dashboard") ? "nb-btn-primary" : ""}`} data-testid="nav-dashboard">
              <House size={18} weight="bold" />
              <span className="hidden sm:inline">Dashboard</span>
            </Link>
            <Link to="/settings" className={`nb-btn ${isActive("/settings") ? "nb-btn-primary" : ""}`} data-testid="nav-settings">
              <Gear size={18} weight="bold" />
              <span className="hidden sm:inline">Pengaturan</span>
            </Link>
            <button onClick={handleLogout} className="nb-btn" data-testid="nav-logout">
              <SignOut size={18} weight="bold" />
              <span className="hidden sm:inline">Keluar</span>
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-2">
            <Link to="/login" className="nb-btn" data-testid="nav-login">Masuk</Link>
            <Link to="/register" className="nb-btn nb-btn-primary" data-testid="nav-register">Daftar Gratis</Link>
          </div>
        )}
      </div>
    </nav>
  );
}
